import React from 'react'
import Header from '@Components/Header';
import Footer from '@Components/Footer';
import enableSiniestrosMenu from '@hooks/enableSiniestrosMenu';

function MainLayout(props) {
    const { children } = props;
    const { isSiniestrosMenuEnabled } = enableSiniestrosMenu();

    return (
        <div className="app-layout">
            <Header
                {...props}
                showBackButton={false}
                showNotificationPanel
                showProfileBadge
                showNavbar
                showHamburgerMenu
                token={true}
                isSiniestrosMenuEnabled={isSiniestrosMenuEnabled}
            />
            <main className="app-content">
                <section className="master-page">
                    {children}
                </section>
            </main>
            <Footer />
        </div>
    )
}

export default MainLayout;
